/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { skipAutoDateConversion, parseDateTime } from '../../../api-dates';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { PeriodicJobRecordDto as PlatformPeriodicJobRecordDto } from '../../models/platform/periodic-job-record-dto';

export interface GetPeriodicJobs$Params {
}

export function getPeriodicJobs(http: HttpClient, rootUrl: string, params?: GetPeriodicJobs$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<PlatformPeriodicJobRecordDto>>> {
  const rb = new RequestBuilder(rootUrl, getPeriodicJobs.PATH, 'get');
  if (params) {
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context: skipAutoDateConversion(context) })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r.clone({ body: reviveResponseBody(r.body) }) as StrictHttpResponse<Array<PlatformPeriodicJobRecordDto>>;
    })
  );
}

getPeriodicJobs.PATH = '/administration/periodic-jobs';

function revivePlatformPeriodicJobRecordDto(value: any): any {
  if (value) {
    if (value["inProgressStartTime"] != null) {
      value["inProgressStartTime"] = parseDateTime(value["inProgressStartTime"]);
    }
    if (value["completedTime"] != null) {
      value["completedTime"] = parseDateTime(value["completedTime"]);
    }
  }
  return value;
}

function reviveResponseBody(body: any): any {
  if (body) {
    for (let i0 = 0; i0 < body.length; i0++) {
      if (body[i0] != null) {
        body[i0] = revivePlatformPeriodicJobRecordDto(body[i0]);
      }
    }
  }
  return body;
}
